export default {
  accountCreated:
    'Contul a fost creat. Te rugăm să îți verifici adresa de e-mail și să urmezi procedura de validare a e-mail-ului iar apoi vei putea să îți configurezi contul.',
  FAILED_TO_ACTIVATE:
    'Se întâmplă ceva neobișnuit. Nu am putut activa contul. Te rugăm să verifici e-mail-ul sau să trimiți un mesaj pentru asistență la contact@sportya.net',
  SUCCESSFULLY_ACTIVATED:
     'Felicitări! Ți-ai activat contul cu succes iar acum te poți conecta pentru a continua configurarea acestuia.',
};
